import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F82s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      no_de_expediente: "",
      obra: "",
      ubicacion: "",
      modalidad_de_ejecucion: "",
      no_de_contrato: "",
      nombre_de_la_empresa_contratista: "",
      fecha_de_inicio: "",
      real: "",
      segun_acta: "",
      importe_ejercido: "",
      federal: "",
      estatal: "",
      municipal: "",
      otros: "",
      estatus: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f82s: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  };
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F82/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f82s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/82/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      no_de_expediente: "",
      obra: "",
      ubicacion: "",
      modalidad_de_ejecucion: "",
      no_de_contrato: "",
      nombre_de_la_empresa_contratista: "",
      fecha_de_inicio: "",
      real: "",
      segun_acta: "",
      importe_ejercido: "",
      federal: "",
      estatal: "",
      municipal: "",
      otros: "",
      estatus: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      no_de_expediente: row.no_de_expediente,
      obra: row.obra,
      ubicacion: row.ubicacion,
      modalidad_de_ejecucion: row.modalidad_de_ejecucion,
      no_de_contrato: row.no_de_contrato,
      nombre_de_la_empresa_contratista: row.nombre_de_la_empresa_contratista,
      fecha_de_inicio: row.fecha_de_inicio,
      real: row.real,
      segun_acta: row.segun_acta,
      importe_ejercido: row.importe_ejercido,
      federal: row.federal,
      estatal: row.estatal,
      municipal: row.municipal,
      otros: row.otros,
      estatus: row.estatus,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      no_de_expediente: row.no_de_expediente,
      obra: row.obra,
      ubicacion: row.ubicacion,
      modalidad_de_ejecucion: row.modalidad_de_ejecucion,
      no_de_contrato: row.no_de_contrato,
      nombre_de_la_empresa_contratista: row.nombre_de_la_empresa_contratista,
      fecha_de_inicio: row.fecha_de_inicio,
      real: row.real,
      segun_acta: row.segun_acta,
      importe_ejercido: row.importe_ejercido,
      federal: row.federal,
      estatal: row.estatal,
      municipal: row.municipal,
      otros: row.otros,
      estatus: row.estatus,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      no_de_expediente: row.no_de_expediente,
      obra: row.obra,
      ubicacion: row.ubicacion,
      modalidad_de_ejecucion: row.modalidad_de_ejecucion,
      no_de_contrato: row.no_de_contrato,
      nombre_de_la_empresa_contratista: row.nombre_de_la_empresa_contratista,
      fecha_de_inicio: row.fecha_de_inicio,
      real: row.real,
      segun_acta: row.segun_acta,
      importe_ejercido: row.importe_ejercido,
      federal: row.federal,
      estatal: row.estatal,
      municipal: row.municipal,
      otros: row.otros,
      estatus: row.estatus,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      no_de_expediente: this.state.no_de_expediente,
      obra: this.state.obra,
      ubicacion: this.state.ubicacion,
      modalidad_de_ejecucion: this.state.modalidad_de_ejecucion,
      no_de_contrato: this.state.no_de_contrato,
      nombre_de_la_empresa_contratista: this.state.nombre_de_la_empresa_contratista,
      fecha_de_inicio: this.state.fecha_de_inicio,
      real: this.state.real,
      segun_acta: this.state.segun_acta,
      importe_ejercido: this.state.importe_ejercido,
      federal: this.state.federal,
      estatal: this.state.estatal,
      municipal: this.state.municipal,
      otros: this.state.otros,
      estatus: this.state.estatus,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F82", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      no_de_expediente: this.state.no_de_expediente,
      obra: this.state.obra,
      ubicacion: this.state.ubicacion,
      modalidad_de_ejecucion: this.state.modalidad_de_ejecucion,
      no_de_contrato: this.state.no_de_contrato,
      nombre_de_la_empresa_contratista: this.state.nombre_de_la_empresa_contratista,
      fecha_de_inicio: this.state.fecha_de_inicio,
      real: this.state.real,
      segun_acta: this.state.segun_acta,
      importe_ejercido: this.state.importe_ejercido,
      federal: this.state.federal,
      estatal: this.state.estatal,
      municipal: this.state.municipal,
      otros: this.state.otros,
      estatus: this.state.estatus,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F82/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F82/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeNoDeExpediente = e => {
    this.setState({ no_de_expediente: e.target.value });
  };

  onChangeObra = e => {
    this.setState({ obra: e.target.value });
  };

  onChangeUbicacion = e => {
    this.setState({ ubicacion: e.target.value });
  };

  onChangeModalidadDeEjecucion = e => {
    this.setState({ modalidad_de_ejecucion: e.target.value });
  };

  onChangeNoDeContrato = e => {
    this.setState({ no_de_contrato: e.target.value });
  };

  onChangeNombreDeLaEmpresaContratista = e => {
    this.setState({ nombre_de_la_empresa_contratista: e.target.value });
  };

  onChangeFechaDeInicio = e => {
    this.setState({ fecha_de_inicio: e.target.value });
  };

  onChangeReal = e => {
    this.setState({ real: e.target.value });
  };

  onChangeSegunActa = e => {
    this.setState({ segun_acta: e.target.value });
  };

  onChangeImporteEjercido = e => {
    this.setState({ importe_ejercido: e.target.value });
  };

  onChangeFederal = e => {
    this.setState({ federal: e.target.value });
  };

  onChangeEstatal = e => {
    this.setState({ estatal: e.target.value });
  };

  onChangeMunicipal = e => {
    this.setState({ municipal: e.target.value });
  };

  onChangeOtros = e => {
    this.setState({ otros: e.target.value });
  };

  onChangeEstatus = e => {
    this.setState({ estatus: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };



  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"82"}
            id={row.id}
            disabled={this.state.noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={this.state.noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "no_de_expediente",
        text: "No De Expediente",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "obra",
        text: "Obra",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "ubicacion",
        text: "Ubicacion",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "modalidad_de_ejecucion",
        text: "Modalidad De Ejecucion",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "no_de_contrato",
        text: "No De Contrato",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "nombre_de_la_empresa_contratista",
        text: "Nombre De La Empresa Contratista",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_de_inicio",
        text: "Fecha De Inicio",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "real",
        text: "Real",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "segun_acta",
        text: "Segun Acta",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "importe_ejercido",
        text: "Importe Ejercido",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "federal",
        text: "Federal",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "estatal",
        text: "Estatal",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "municipal",
        text: "Municipal",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "otros",
        text: "Otros",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "estatus",
        text: "Estatus",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">INVENTARIO DE OBRAS PÚBLICAS TERMINADAS</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 82 referente
                a inventario de obras públicas terminadas.
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f82s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="82" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga PDF"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=82"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>            <Col xs="12" md="4" lg="3">
              <Form.Label>
                No De Expediente:
                <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                  <Button
                    tabindex="-1"
                    variant="light"
                    onClick={(e) => {
                      this.setState({ input_tooltip: "Señalar la clave de identificación del expediente de la obra pública que se relaciona." });
                    }}
                  >
                    <FontAwesomeIcon icon={faQuestionCircle} />
                  </Button>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                type="text"
                name="no_de_expediente"
                value={this.state.no_de_expediente}
                onChange={this.onChangeNoDeExpediente}
              />
            </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Obra:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar el nombre de la obra pública de la que se hace referencia." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="obra"
                  value={this.state.obra}
                  onChange={this.onChangeObra}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Ubicacion:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Señalar la localidad donde se ubica la obra pública." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="ubicacion"
                  value={this.state.ubicacion}
                  onChange={this.onChangeUbicacion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Modalidad De Ejecucion:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Modalidad de ejecución de la obra, ya sea por contrato o por administración directa." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="modalidad_de_ejecucion"
                  value={this.state.modalidad_de_ejecucion}
                  onChange={this.onChangeModalidadDeEjecucion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  No De Contrato:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Número de contrato de la obra." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="no_de_contrato"
                  value={this.state.no_de_contrato}
                  onChange={this.onChangeNoDeContrato}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Nombre De La Empresa Contratista:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Nombre de la empresa contratista a quien se le adjudicó el contrato." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nombre_de_la_empresa_contratista"
                  value={this.state.nombre_de_la_empresa_contratista}
                  onChange={this.onChangeNombreDeLaEmpresaContratista}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha De Inicio:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar la fecha de inicio de la obra pública de acuerdo al contrato." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_de_inicio"
                  value={this.state.fecha_de_inicio}
                  onChange={this.onChangeFechaDeInicio}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Real:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar la fecha de término de la obra pública según bitácora o instrumento de control equivalente." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="real"
                  value={this.state.real}
                  onChange={this.onChangeReal}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Segun Acta:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar la fecha de término de la obra pública según Acta Entrega-Recepción de la obra." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="segun_acta"
                  value={this.state.segun_acta}
                  onChange={this.onChangeSegunActa}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Importe Ejercido:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Señalar la suma de todos los tipos de inversión que se ejercieron para la realización de la obra." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="importe_ejercido"
                  value={this.state.importe_ejercido}
                  onChange={this.onChangeImporteEjercido}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Federal:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Registrar las diferentes fuentes de financiamiento para la realización de la obra." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="federal"
                  value={this.state.federal}
                  onChange={this.onChangeFederal}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Estatal:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Registrar las diferentes fuentes de financiamiento para la realización de la obra." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="estatal"
                  value={this.state.estatal}
                  onChange={this.onChangeEstatal}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Municipal:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Registrar las diferentes fuentes de financiamiento para la realización de la obra." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="municipal"
                  value={this.state.municipal}
                  onChange={this.onChangeMunicipal}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Otros:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Registrar las diferentes fuentes de financiamiento para la realización de la obra." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="otros"
                  value={this.state.otros}
                  onChange={this.onChangeOtros}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Estatus:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Anotar el estatus en que se encuentra la obra pública, referente a su funcionamiento (opera, no opera, opera con deficiencias, etc.)" });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="estatus"
                  value={this.state.estatus}
                  onChange={this.onChangeEstatus}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Observaciones o comentarios sobre el estado que guardan las obras." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} disabled={this.state.noEdit}>
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      No De Expediente:
                    </Col>
                    <Col xs={10}>{this.state.no_de_expediente}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Obra:
                    </Col>
                    <Col xs={10}>{this.state.obra}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Ubicacion:
                    </Col>
                    <Col xs={10}>{this.state.ubicacion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Modalidad De Ejecucion:
                    </Col>
                    <Col xs={10}>{this.state.modalidad_de_ejecucion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      No De Contrato:
                    </Col>
                    <Col xs={10}>{this.state.no_de_contrato}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Nombre De La Empresa Contratista:
                    </Col>
                    <Col xs={10}>{this.state.nombre_de_la_empresa_contratista}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha De Inicio:
                    </Col>
                    <Col xs={10}>{this.state.fecha_de_inicio}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Real:
                    </Col>
                    <Col xs={10}>{this.state.real}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Segun Acta:
                    </Col>
                    <Col xs={10}>{this.state.segun_acta}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Importe Ejercido:
                    </Col>
                    <Col xs={10}>{this.state.importe_ejercido}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Federal:
                    </Col>
                    <Col xs={10}>{this.state.federal}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Estatal:
                    </Col>
                    <Col xs={10}>{this.state.estatal}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Municipal:
                    </Col>
                    <Col xs={10}>{this.state.municipal}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Otros:
                    </Col>
                    <Col xs={10}>{this.state.otros}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Estatus:
                    </Col>
                    <Col xs={10}>{this.state.estatus}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>

                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout>
    );
  }
}

export default F82s;
